{
	"loadingMessage": "Loading accounts...",
	"errorMessage": "Error loading data",
	"emptyMessage": "No accounts found",
	"noSearchResults": "Chart of accounts not found",
	"searchHint": "Search for a registered chart of accounts"
}
